import { render, staticRenderFns } from "./warningEvent.vue?vue&type=template&id=5e4b31d5"
import script from "./warningEvent.vue?vue&type=script&lang=js"
export * from "./warningEvent.vue?vue&type=script&lang=js"
import style0 from "./warningEvent.vue?vue&type=style&index=0&id=5e4b31d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports